import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass/styled-components';
import styled from 'styled-components';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { Toolbox } from './ToolBox';
import Modal from 'styled-react-modal';
import * as Yup from 'yup';
import withSession from '../../../lib/withSession';
// import { GET_HEALTHCOACH_FORM_TARGETS, GET_HEALTHCOACH_FORM_TEMPLATES } from '../../../graphql';
import { GetAvailables } from './common/availableToolboxItems';
import { SpecialModalBackground } from '../../../components/Commons';
import { parseStringify } from '../../../utils/StringUtils';
import { IProperties } from './types';
import MainDroppable from './MainDroppable';
import { ICurrentUserOutput, IUser } from '../../../graphql/types/queries/user';
import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { PreviewHcForm } from './Preview';
import SaveModal from './SaveModal';
import moment from 'moment';

const BoxRight = styled(Flex)`
  width: 33vw;
  max-width: 400px;
  justify-content: flex-end;
  padding: 0 8px;
`;

const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

const schema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .min(2, 'Question must be greater than 1 character')
    .required('Required'),
});

export interface IFormMeta {
  id?: string,
  name: string,
  version: string | number,
  description?: string,
  target: string,
  targetName: string,
  basedOnTemplate: string
  templateBuilderUpdatedAt?: string
  formBuilderUpdatedAt?: string
}
interface IProps {
  meta: IFormMeta,
  templateTree: Array<IProperties>,
  session: IUser,
  refetchSession: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<ICurrentUserOutput>>
}

const HealthCoachFormBuilder: React.FC<IProps> = ({ session, meta, templateTree }) => {

  const navigate = useNavigate()
  const [isSaving, setIsSaving] = useState(false)
  const [tree, setTree] = useState<Array<IProperties>>(templateTree);
  const [initialTree, setInitialTree] = useState<Array<IProperties>>(templateTree);
  const [hasChanged, setHasChanged] = useState(false);
  const [availables, setAvailables] = useState(GetAvailables());
  const [showPreview, setShowPreview] = useState(false);
  const [newlyAddedTemplateFields, setNewlyAddedTemplateFields] = useState<Array<IProperties>>()
  const [isShowNewlyAddedTemplateFields, setIsShowNewlyAddedTemplateFields] = useState(false)
  const [duplicatesResearchId, setDuplicatesResearchId] = useState<Array<{
    researchId: string,
    foundIn: Array<string>,
  }>>([]);

  const escFunction = useCallback((event: any) => {
    if (event.key === 'Escape') {
      event.stopPropagation();
    }
  }, []);

  useEffect(() => {
    if (!meta || !meta.templateBuilderUpdatedAt || !meta.formBuilderUpdatedAt) return

    const newFields = []
    for (let index = 0; index < templateTree.length; index++) {
      const element = templateTree[index];
      if (!!(element.params || {}).isHealthCoachCreated) continue

      const id = element.id
      const sp = id.split('_')
      if (sp.length < 2) continue
      const dt = moment(parseInt(sp[1]))

      if (moment(meta.formBuilderUpdatedAt).isBefore(dt)) {
        newFields.push(element)
      }
    }

    if (newFields.length > 0) {
      setNewlyAddedTemplateFields(newFields)
      setIsShowNewlyAddedTemplateFields(true)
    }
  }, [])

  useEffect(
    () => {
      document.addEventListener('keydown', escFunction, true);

      return () => {
        document.removeEventListener('keydown', escFunction, true);
      };
    },
    [escFunction]
  );

  useEffect(
    () => {
      if ((initialTree || []).length !== (tree || []).length) {
        setHasChanged(true);
        return;
      }
      for (let index = 0; index < initialTree.length; index++) {
        const element = (initialTree || [])[index];
        if (index > (tree || []).length) {
          setHasChanged(true);
          return;
        }
        if (element.id !== (tree || [])[index].id) {
          setHasChanged(true);
          return;
        }
      }

      setHasChanged(false);
    },
    [tree]
  );
  const handleOnDragEnd = (result: DropResult) => {
    console.log({ handleOnDragEnd: result })
    if (!result.source.droppableId) return;
    if (result.source.droppableId === 'characters' && (!result.destination || result.destination.droppableId === 'availables')) {
      return;
    }
    if (!result.destination || !result.destination.droppableId) return;
    if (result.source.droppableId === result.destination.droppableId) {
      if (result.source.droppableId === 'availables') return;
      console.log('12', { result });
      const items = Array.from(tree);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setTree(items);
    } else if (result.source && result.destination) {
      console.log('13');

      const items = Array.from(tree);
      const destClone = Array.from(availables);
      const [el] = destClone.splice(result.source.index, 1);
      const [el2] = Array.from(availables).splice(result.source.index - 1, 1);
      const newOne = JSON.parse(JSON.stringify(el2));
      newOne.id = `${newOne.id}_${new Date().getTime()}`;

      if (newOne.key === 'NumberInput') {
        newOne.params = {
          isHealthCoachCreated: true,
          ctrlProps: {
            type: 'number',
          },
        };
      } else if (newOne.key === 'Email') {
        newOne.params = {
          isHealthCoachCreated: true,
          ctrlProps: {
            type: 'email',
            placeholder: 'email@email.com',
          },
        };
      } else if (newOne.key === 'Date') {
        newOne.params = {
          isHealthCoachCreated: true,
          ctrlProps: {
            type: 'date',
            placeholder: 'MM/DD/YYYY',
          },
        };
      } else if (newOne.key === 'Range') {
        newOne.params = {
          isHealthCoachCreated: true,
          ctrlProps: {
            type: 'range',
            min: 0,
            max: 100,
          },
        };
      } else {
        newOne.params = {
          isHealthCoachCreated: true,
          // researchId: '',
          ctrlProps: {},
        };
      }
      items.splice(result.destination.index, 0, newOne);
      destClone.splice(result.destination.index, 0, el);
      setAvailables(destClone);

      setTree(items);
    }
  };
  // const resTree = parseStringify(tree);

  return (
    <Flex flexDirection={'column'} flex={1} p={4}>
      <Flex mb={2} style={{ borderBottom: '1px solid #344f79', paddingBottom: '12px' }}>
        <Heading flex={1}>
          {(meta || {}).name}
          {!!hasChanged ? '*' : ''}
        </Heading>

        <Button
          variant={'primary'}
          style={{
            padding: '4px 12px',
            alignSelf: 'center',
            marginRight: '12px',
          }}
          onClick={() => {
            const dups = [];

            for (let index = 0; index < tree.length; index++) {
              const element = tree[index];
              if (!element || !element.params || !element.params.researchId) continue;
              const ind = dups.findIndex((xx) => xx.researchId === element.params.researchId);

              if (ind < 0) {
                dups.push({
                  researchId: element.params.researchId,
                  foundIn: [element.params.question],
                });
              } else {
                dups[ind].foundIn.push(element.params.question);
              }
            }
            if (dups && dups.filter((xx) => (xx.foundIn || []).length > 1).length > 0) {
              console.log({
                dups: dups.filter((xx) => (xx.foundIn || []).length > 1),
              });
              setDuplicatesResearchId(dups.filter((xx) => (xx.foundIn || []).length > 1));
              return;
            }
            let params = {
              id: undefined,
              tree: parseStringify(tree),
              user: session.id,
              name: meta.name,
              description: meta.description,
              version: meta.version.toString(),
              target: meta.target,
              basedOnTemplate: meta.basedOnTemplate
            };
            console.log({ params });
            setIsSaving(true)
          }}
        >
          Save
        </Button>

        <Button
          variant={'pink'}
          style={{
            padding: '4px 12px',
            alignSelf: 'center',
            marginRight: '12px',
          }}
          onClick={() => {
            setShowPreview(true);
          }}
        >
          Show preview
        </Button>
      </Flex>
      <Text>Target: {(meta || {}).targetName}</Text>
      <Flex mb={4}>
        <Text fontSize={'12px'} style={{ opacity: 0.5 }} mr={4}>
          Version: 1
        </Text>
        <Text fontSize={'12px'} style={{ opacity: 0.5 }}>
          Created By: {session.firstName} ({session.email})
        </Text>
      </Flex>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Flex flex={1} style={{ height: '100%', minHeight: '80vh', width: '100%' }}>
          <Flex flexDirection={'column'} flex={1} style={{ height: '100%', minHeight: '80vh' }}>
            <Text fontWeight={300} mb={4} style={{ whiteSpace: 'pre-line' }}>
              {(meta || {}).description}
            </Text>
            <Flex flex={1}>
              <MainDroppable tree={tree} setTree={setTree} lastTemplateEdit={(meta || {}).formBuilderUpdatedAt}/>
            </Flex>
          </Flex>
          <BoxRight>
            <Flex style={{ width: '100%' }} flexDirection={'column'}>
              <Text fontWeight={500} fontSize={'18px'} ml={'20px'}>
                ToolBox
              </Text>
              <Flex id="ttxx">
                <Toolbox availables={availables} />
              </Flex>
            </Flex>
          </BoxRight>
        </Flex>
      </DragDropContext>
      {isSaving && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsSaving(false);
          }}
          onEscapeKeydown={() => {
            setIsSaving(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsSaving(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: 'auto',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <SaveModal meta={meta} tree={tree} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {duplicatesResearchId &&
        duplicatesResearchId.length > 0 && (
          <Modal
            isOpen={true}
            onBackgroundClick={() => {
              setShowPreview(false);
            }}
            onEscapeKeydown={() => {
              setShowPreview(false);
            }}
          >
            <SpecialModalBackground
              onClick={() => {
                setShowPreview(false);
              }}
            >
              <Box
                style={{
                  margin: '0 auto',
                  alignSelf: 'center',
                  borderRadius: '20px',
                  position: 'relative',
                  background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  maxWidth: '95vw',
                  minWidth: 'initial',
                  maxHeight: '95vh',
                  minHeight: 'auto',
                  overflowY: 'hidden',
                }}
                onClick={(e) => {
                  // e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                  <Flex flexDirection={'column'}>
                    <Heading textAlign={'center'} mb={4}>
                      Duplicate research Id found:
                    </Heading>
                    <Text mb={3}>Research Ids must be unique across a form. Here are the duplicates identified:</Text>
                    {duplicatesResearchId.map((x) => {
                      return (
                        <Flex key={x.researchId} mb={2}>
                          <Text fontWeight={'500'}>- "{x.researchId}"</Text>
                          <Text ml={2} mr={2}>
                            found in:
                          </Text>
                          <Text>"{x.foundIn.join('", "')}"</Text>
                        </Flex>
                      );
                    })}
                    <Button variant={'primary'} mt={4} alignSelf={'center'} onClick={() => setDuplicatesResearchId([])}>
                      OK
                    </Button>
                  </Flex>
                </Wrapper>
              </Box>
            </SpecialModalBackground>
          </Modal>
        )}

      {isShowNewlyAddedTemplateFields &&
        newlyAddedTemplateFields &&
        newlyAddedTemplateFields.length > 0 && (
          <Modal
            isOpen={true}
            onBackgroundClick={() => {
              setShowPreview(false);
            }}
            onEscapeKeydown={() => {
              setShowPreview(false);
            }}
          >
            <SpecialModalBackground
              onClick={() => {
                setShowPreview(false);
              }}
            >
              <Box
                style={{
                  margin: '0 auto',
                  alignSelf: 'center',
                  borderRadius: '20px',
                  position: 'relative',
                  background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                  maxWidth: '95vw',
                  minWidth: 'initial',
                  maxHeight: '95vh',
                  minHeight: 'auto',
                  overflowY: 'hidden',
                }}
                onClick={(e) => {
                  // e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                  <Flex flexDirection={'column'}>
                    <Heading textAlign={'center'} mb={4}>
                      The owner of the template added some fields
                    </Heading>
                    <Text mb={3}>Here are the newly added ones (they are currently located at the end of your form, you can relocate them):</Text>
                    {newlyAddedTemplateFields.map((x) => {
                      return (
                        <Flex ml={3} key={`newlyAdded_${x.id}`} mb={2}>
                          <Text >- {x.params.question}</Text>

                          <Box ml={3} style={{ background: '#6c757d', borderRadius: '8px', padding: '2px 8px' }}>
                            <Text fontSize={'12px'} color="white">
                              {x.name}
                            </Text>
                          </Box>
                        </Flex>
                      );
                    })}
                    <Button variant={'primary'} mt={4} alignSelf={'center'} onClick={() => setIsShowNewlyAddedTemplateFields(false)}>
                      OK
                    </Button>
                  </Flex>
                </Wrapper>
              </Box>
            </SpecialModalBackground>
          </Modal>
        )}
      {showPreview && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setShowPreview(false);
          }}
          onEscapeKeydown={() => {
            setShowPreview(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setShowPreview(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                // e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <PreviewHcForm tree={tree} meta={meta} close={() => setShowPreview(false)} />
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Flex>
  );
};

export default withSession(HealthCoachFormBuilder)
